/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Col, Row, Typography } from 'antd';
import { RegulateLevelPhysicalActivityFilter } from '@/components/forms/regulate-level-physical-activity.filter.form';
import { RegulateLevelPhysicalActivityTable } from '@/components/tables/regulate-level-physical-activity.table';
import { useCallback, useState } from 'react';
import { PAGINATION_PARAMS } from '@/constants/pagination.constant';
import { useAppDispatch } from '@/redux/hooks';
import { getListPhysicalActivity } from '@/redux/slices/regulate-level-physical-activity.slice';

type PageChangeParams = {
    page?: number;
    pageSize?: number;
    filter?: FilterPhysicalActivity;
};

export default function RegulateLevelPhysicalActivity(){
    const dispatch = useAppDispatch();
    const [filter, setFilter] = useState<FilterPhysicalActivity>({});
    const handlePageChange = useCallback(
        ({
          page = PAGINATION_PARAMS.offset,
          pageSize = PAGINATION_PARAMS.limit,
          filter
        }: PageChangeParams) => {
          dispatch(
            getListPhysicalActivity({
              ID_OPTIONS: filter?.idOptions,
              AGE_MAX: filter?.ageMax !== undefined && Number(filter?.ageMax) === 0 ? null : Number(filter?.ageMax),
              AGE_MIN: filter?.ageMin !== undefined && Number(filter?.ageMin) === 0 ? null : Number(filter?.ageMin),
              NAME: filter?.textSearch,
              page: page,
              limit: pageSize
            })
          );
        },
        [dispatch]
    );
    const handleSearch = (values: FilterPhysicalActivity) => {
        const isReset = Object.keys(values).length === 0;
        const newFilter = isReset ? {} : { ...filter, ...values };
        setFilter(newFilter);
        handlePageChange({ filter: newFilter });
    };
    
    return(
      <div css={rootStyles}>
        <Row css={boxStyles} justify='space-between' align='middle'>
            <Col>
            <Typography.Title css={titleStyles} level={5}>
                Danh sách công việc theo mức độ hoạt động thể lực
            </Typography.Title>
            </Col>
        </Row>
        <div css={boxStyles}>
            <RegulateLevelPhysicalActivityFilter onSearch={handleSearch} />
        </div>
        <div css={tableStyles}>
            <RegulateLevelPhysicalActivityTable
                handleSearch={handleSearch}
                handlePageChange={handlePageChange}
                filter={filter}
            />
        </div>
      </div>
    )
}

const rootStyles = css`
  background: var(--gray-soft-color);
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  margin-top: 1rem;
  min-height: calc(100vh - var(--header-height));
`;

const boxStyles = css`
  margin-top: 0.5rem;
  padding: 1rem;
  background: var(--white-color);
  box-shadow: 0.02rem 0.04rem 0.2rem var(--gray-light-color);
  &:nth-of-type(2) {
    padding: 1.6rem 1rem;
  }
`;

const tableStyles = css`
  background: var(--white-color);
  border-radius: 1rem;
  padding: 0 1rem;
  .table-top {
    padding: 1rem 0;
  }
`;

const titleStyles = css`
  margin-bottom: 0 !important;
  line-height: 3.2rem !important;
`;